import { ReactElement } from 'react';
import Typography from '@mui/material/Typography';
import { DatePickerToolbarProps } from '@mui/x-date-pickers/DatePicker';
import { usePickerAdapter, usePickerContext } from '@mui/x-date-pickers/hooks';
import { PickersToolbar } from '@mui/x-date-pickers/internals';

const DatePickerToolbar = ({ className }: DatePickerToolbarProps): ReactElement => {
  const adapter = usePickerAdapter();
  const { value, view, setView, views } = usePickerContext();

  const isValid = value !== null && adapter.isValid(value);
  const yearText = isValid ? adapter.format(value, 'year') : '––';
  const dateText = isValid ? adapter.format(value, 'normalDateWithWeekday') : '––';
  const hasYearView = views.includes('year');

  return (
    <PickersToolbar className={className} toolbarTitle="">
      {hasYearView && (
        <Typography
          variant="subtitle1"
          onClick={() => setView('year')}
          sx={{
            cursor: 'pointer',
            color: 'primary.contrastText',
            opacity: view === 'year' ? 1 : 0.7,
          }}
        >
          {yearText}
        </Typography>
      )}
      <Typography
        variant="h4"
        onClick={() => views.includes('day') && setView('day')}
        sx={{
          cursor: 'pointer',
          color: 'primary.contrastText',
          opacity: !hasYearView || view === 'day' ? 1 : 0.7,
        }}
      >
        {dateText}
      </Typography>
    </PickersToolbar>
  );
};

export default DatePickerToolbar;
